import { render, staticRenderFns } from "./tournamentVideos.vue?vue&type=template&id=757ecf40&scoped=true&"
import script from "./tournamentVideos.vue?vue&type=script&lang=js&"
export * from "./tournamentVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757ecf40",
  null
  
)

export default component.exports